/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import { withLDProvider, useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { logger } from '@sendpayments/js-utils';
import { isEmpty } from 'lodash';

const WithFeaturesToggleProvider = (App, credentials) => {
  logger.log(
    '@sendpayments/react-shared/components/FeaturesToggleProvider',
    `Feature switches initializing with credentials`,
    credentials,
  );

  if (isEmpty(credentials.clientSideID)) {
    logger.error(
      '@sendpayments/react-shared/components/FeaturesToggleProvider',
      `There is some missing configuration, starting the app without features enables`,
      credentials,
    );

    return App;
  }

  return withLDProvider({
    clientSideID: credentials.clientSideID,
    user: { key: 'anonymous', anonymous: true },
    options: {
      bootstrap: 'localStorage',
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  })(App);
};

const Wrapper = ({ children, allowDevTools, userEmail }) => {
  const flags = useFlags();
  const ldClient = useLDClient();

  useEffect(() => {
    logger.log('@sendpayments/react-shared/components/FeaturesToggleProvider', `Feature switches initialized`, userEmail);

    return () => {
      logger.log('@sendpayments/react-shared/components/FeaturesToggleProvider', `Feature switches where destroyed`, userEmail);
    };
  }, []);

  useEffect(() => {
    if (userEmail && ldClient?.identify) {
      logger.log('@sendpayments/react-shared/components/FeaturesToggleProvider', `using user ${userEmail}`);
      ldClient.identify({ key: userEmail, email: userEmail });
    }
  }, [userEmail, ldClient]);

  useEffect(() => {
    logger.log('@sendpayments/react-shared/components/FeaturesToggleProvider', `flags updated`, flags);
    if (window._REACT_CONTEXT_DEVTOOL && flags && allowDevTools) {
      window._REACT_CONTEXT_DEVTOOL({
        id: 'Features',
        displayName: 'Features',
        values: flags,
      });
    }
  }, [flags]);

  return <>{children}</>;
};

export default ({ credentials }) => WithFeaturesToggleProvider(Wrapper, credentials);
